// Formato monetario es-ES del producto: agrupación de miles SIEMPRE.
// Intl es-ES no agrupa enteros de 4 cifras (2420 → "2420,00 €"), así que
// se formatea a mano (mismo criterio que el generador de PDFs).
export function formatCurrency(amount) {
  const n = Number(amount) || 0;
  const [int, dec] = Math.abs(n).toFixed(2).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${n < 0 ? "-" : ""}${grouped},${dec} €`;
}

export function formatSignedCurrency(amount) {
  const n = Number(amount) || 0;
  return n > 0 ? `+${formatCurrency(n)}` : formatCurrency(n);
}

export function formatDateShort(isoDate) {
  if (!isoDate) return "-";
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function formatCurrencyIn(amount, currency = "EUR") {
  if (!currency || currency === "EUR") return formatCurrency(amount);
  const n = Number(amount) || 0;
  return new Intl.NumberFormat("es-ES", { style: "currency", currency }).format(n);
}
